import {getCookie} from "./utils";
import {ProductModel} from "./ProductModel";

export const ModelProductList = (products) => {
    let productsModeled = [];
    const init = JSON.parse(localStorage.getItem('init'));
    const selectedCountry = getCookie('selectedCountry') ? JSON.parse(getCookie('selectedCountry')) : null;
    products.forEach((product) => {
        product && productsModeled.push(ProductModel(product, selectedCountry, init));
    });
    return productsModeled;
}